import { axiosInstance } from './axiosInstance';

export function getUniStudents(id, token) {
    return axiosInstance(token,id).get("/api/v1/students")
}